export const FETCH_VETTINGS = 'FETCH_VETTINGS';
export const DONE_FETCHING_VETTINGS = 'DONE_FETCHING_VETTINGS';
export const ERROR_FETCHING_VETTINGS = 'ERROR_FETCHING_VETTINGS';

export const CREATE_VETTING_REQUEST = 'CREATE_VETTING_REQUEST';
export const DONE_CREATING_VETTING_REQUEST = 'DONE_CREATING_VETTING_REQUEST';
export const ERROR_CREATING_VETTING_REQUEST = 'ERROR_CREATING_VETTING_REQUEST';

export const REMOVE_VETTING_ERROR = 'REMOVE_VETTING_ERROR';
